import ListStandard from './ListStandard'
import ListStandardAction from './ListStandardAction'
import ListStandardRow from './ListStandardRow'

ListStandard.Action = ListStandardAction
ListStandard.Row = ListStandardRow

export default ListStandard
